import React from 'react';

interface AvatarProps {
    alt:string;
    src:string;
    square?:boolean;
    size:number;
}

export default function Avatar(props:AvatarProps){
    const {src, size, alt, square} = props;
    if(src) {
       return <img
           src={src} style={{minWidth: size,
           maxHeight:size,
           maxWidth:size,
           objectFit:'cover', minHeight: size
       }} className={`border border-base-200 ${square ? 'rounded-lg' : 'rounded-full'}`} alt={alt}/>
    }else {
        return <div
            className={`border border-base-200 text-base ${square ? 'rounded-lg' : 'rounded-full'}`}
            style={{minWidth:size, minHeight:size,
                maxWidth:size,
                maxHeight:size,
                fontSize:size/2, display:'flex', justifyContent:'center', alignItems:'center'}}>{alt[0].toUpperCase()}</div>
        }
}